// Formatting + color helpers for the quant terminal

export function scoreMeta(s) {
  if (s == null) return { label: "N/A", color: "#64748B" };
  if (s >= 80) return { label: "Strong Buy", color: "#00E5FF" };
  if (s >= 65) return { label: "Buy", color: "#34D399" };
  if (s >= 55) return { label: "Weak Buy", color: "#10B981" };
  if (s >= 45) return { label: "Neutral", color: "#FBBF24" };
  if (s >= 35) return { label: "Weak Sell", color: "#F59E0B" };
  if (s >= 20) return { label: "Sell", color: "#F97316" };
  return { label: "Strong Sell", color: "#EF4444" };
}

export const chgColor = (v) => (v == null ? "#94A3B8" : v >= 0 ? "#10B981" : "#EF4444");

export function fmt(v, d = 2) {
  if (v == null || Number.isNaN(v)) return "—";
  return Number(v).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}

export const pct = (v, d = 2) => (v == null ? "—" : `${v >= 0 ? "+" : ""}${fmt(v, d)}%`);

export function corrColor(v) {
  if (v == null) return "#141C2E";
  const t = Math.max(-1, Math.min(1, v));
  if (t >= 0) {
    const a = 0.12 + t * 0.6;
    return `rgba(16,185,129,${a})`;
  }
  const a = 0.12 + Math.abs(t) * 0.6;
  return `rgba(239,68,68,${a})`;
}

export const trendColor = (dir) => (dir > 0 ? "#10B981" : dir < 0 ? "#EF4444" : "#F59E0B");

export const classColors = {
  equity: "#00E5FF",
  etf_equity: "#3B82F6",
  commodity: "#F59E0B",
  fixed_income: "#8B5CF6",
  forex: "#22D3EE",
  crypto: "#F97316",
  volatility: "#EF4444",
};

export const classLabel = {
  equity: "Equity",
  etf_equity: "ETF / Index",
  commodity: "Commodity",
  fixed_income: "Fixed Income",
  forex: "Forex",
  crypto: "Crypto",
  volatility: "Volatility",
};

export const subScoreOrder = [
  ["macro", "Macro"],
  ["technical", "Technical"],
  ["momentum", "Momentum"],
  ["fundamental", "Fundamental"],
  ["seasonal", "Seasonality"],
  ["analyst", "Analyst"],
  ["volatility", "Volatility"],
  ["liquidity", "Liquidity"],
];

export const regimeColor = (r) => {
  const m = {
    expansion: "#10B981", late_expansion: "#84CC16", reflation: "#F59E0B",
    stagflation: "#EF4444", slowdown: "#F59E0B", recession: "#EF4444",
    disinflation: "#00E5FF",
  };
  return m[r] || "#8B5CF6";
};
